/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './activity/Activity.js';
import './admin/admin.js';
import './alert/Alert.js';
import './batch/Batch.js';
import './header/MobileHeader.js';
import './menu/Menu.js';
import './support/support.js';

/**
 * Top level grouping module for the mobile views.
 */
angular.module('mobile', [
  'mobile.activity',
  'mobile.admin',
  'mobile.alert',
  'mobile.batch',
  'mobile.batchstart',
  'mobile.header',
  'mobile.menu',
  'mobile.support'
]);
